module.exports = __webpack_public_path__ + "static/media/Bluetooth.5354d0a7.svg";